// @ts-check
import { useEffect, useState } from 'react';
import SearchInput from '../SearchInput';
import isFunction from 'lodash/isFunction';
import { FixedSizeList as List } from 'react-window';
import deburr from 'lodash/deburr';

const ListItem = ({ style, data, index }) => {
  const item = data?.[index];

  if (!item) {
    return null;
  }

  return (
    <div
      className='cursor-pointer p-1 flex flex-row text-xs overflow-hidden'
      style={style}
    >
      {item.view}
    </div>
  );
};

export const SearchableList = ({
  placeholder,
  items,
  searchKeys,
  emptyState
}) => {
  const [displayedItems, setDisplayedItems] = useState(items);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setDisplayedItems(items);
    setSearchValue('');
  }, [items]);

  const onSearch = input => {
    setSearchValue(input);
    const filteredItems = items.filter(
      item =>
        !!searchKeys
          .map(id => {
            const keyValue = deburr(item[id]) || '';
            return keyValue
              .toString()
              .toLowerCase()
              .includes(deburr(input).toLowerCase());
          })
          .filter(Boolean).length
    );

    setDisplayedItems(filteredItems);
  };

  return (
    <div className='w-full h-full p-2 flex flex-col rounded-sm border border-slate-200 box-border'>
      <div className='mb-3 -mx-2 px-4 w-full box-border'>
        <SearchInput
          value={searchValue}
          onChange={onSearch}
          placeholder={placeholder}
          height='3.3rem'
        />
      </div>

      {!displayedItems.length && (
        <>{isFunction(emptyState) ? emptyState(searchValue) : emptyState}</>
      )}

      {displayedItems.length > 0 && (
        // @ts-ignore
        <List
          height={300}
          itemData={displayedItems}
          itemCount={displayedItems.length}
          itemSize={40}
        >
          {ListItem}
        </List>
      )}
    </div>
  );
};
